import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';

import Modal from '../Modal';
import {Button, buttonTypes} from "../Button";

import './Popup.scss';


class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isShow: false,
    }
  }

  static defaultProps = {
    isShow: false,
  };

  static propTypes = {
    close: PropTypes.func,
    isShow: PropTypes.bool,
    classIcon: PropTypes.string,
    classPopup: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.object,
    body: PropTypes.object,
    buttons: PropTypes.bool
  };


  render() {

    const {
      isShow,
      classIcon,
      title,
      body,
      buttons,
      close,
      classPopup,
      className
    } = this.props;

    const classBlock = classes('popup', `popup__${classPopup}`, className)

    return (
      <Modal
        classModal="authentication"
        isOpen={isShow}
        onRequestClose={close}
        showCloseIcon
        shouldCloseOnOverlayClick={false}
      >
        <div className={classBlock}>
          {
            classIcon ?
              <p className={classes('popup__icon not-font ', classIcon)}>icon</p>
              : null
          }
          {
            title ?
              <h3 className="modal__title popup__title">{title}</h3>
              : null
          }
          {
            body ?
              <div className="popup__body">{body}</div>
              : null
          }
          {
            buttons ?
              <div className="popup__buttons">
                <Button name="save" type={buttonTypes.AUTHENTICATION} />
                <Button name="cancel" />
              </div>
              : null
          }

        </div>
      </Modal>
    )
  }
}

export default Popup;


// WEBPACK FOOTER //
// ./src/app/components/Popup/index.js